export default function CNull() {
  return <h2>C Null</h2>;
}
